export default __webpack_public_path__ + "static/media/gallery_06.609d5669.jpg";